import React, { FunctionComponent } from 'react'

import { VehicleKBA } from '../../../domain'
import { TExtends } from '../../../infrastructure/internationalisation'
import { VehicleCardKBA, VehicleTabsKBA } from '../../organisms/vehicle'
import { FormInputProps } from '../types'

interface VehicleTabsFormInputMetaKBA {
  profile?: string
}

export const VehicleTabsFormInputKBA: FunctionComponent<
  FormInputProps<VehicleKBA, VehicleTabsFormInputMetaKBA>
> = ({ value, onChange, t, tKey, tName, meta }) =>
  value ? (
    <VehicleCardKBA value={value} onChange={onChange} />
  ) : (
    <VehicleTabsKBA
      t={t}
      tName={tName}
      onChange={onChange}
      initialTab={0}
      tKey={TExtends(tKey, tName)}
      config={{
        profile: meta?.profile,
      }}
      value={value?.[0] ?? null}
    />
  )
